import React from 'react'
import ImportLayout from './ImportLayout'

const Simulate = () => <ImportLayout isSimulation />

export default Simulate